import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const getPartnerGMManagerWithImage = async (partnerId: string) => {
  const crud = CrudStore.get(
    CrudStoreItemPartner360.PartnerContacts,
    'getPartnerGMManagerWithImage'
  )
  crud.setSort({ field: 'EntryId', dir: 'desc' })
  crud.setPaging({ pageSize: 1, page: 0 })
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        value: partnerId,
        operator: Operator.EQUAL,
      },
      {
        field: 'Role',
        value: 'General Manager',
        operator: Operator.EQUAL,
      },
      {
        logic: Logic.OR,
        filters: [
          {
            logic: Logic.AND,
            filters: [
              {
                field: 'Image',
                operator: Operator.ISNOTNULL,
                value: '',
              },
              {
                field: 'Image',
                value: '',
                operator: Operator.NOTEQUAL,
              },
            ],
          },
        ],
      },
    ],
  })

  const res = await crud.fetch({ force: true })
  return res?.items[0] || null
}
